<script lang="ts" setup>
interface CardHeaderProps {
  textAlign?: "left" | "center" | "right";
}
const { textAlign = "center" } = defineProps<CardHeaderProps>();
</script>
<template>
  <div :class="{ 'card-header': true, [`text-${textAlign}`]: true }">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.card-header {
  display: flex;
  padding-bottom: $spacing-4;
  flex-direction: column;
  align-items: flex-start;
  gap: $spacing-2;
  align-self: stretch;
}
.text-center {
  align-items: center;
  text-align: center;
}
.text-right {
  align-items: flex-end;
  text-align: right;
}
.text-left {
  align-items: flex-start;
  text-align: left;
}
</style>
